(() => {
  'use strict';

  const roots = document.querySelectorAll(
    '[data-f2w-fighter-detail]'
  );

  if (!roots.length) return;

  const setHidden = (node, hidden) => {
    if (!node) return;

    node.hidden = hidden;
    node.classList.toggle(
      'f2w-arrow--hidden',
      hidden
    );
    node.disabled = hidden;
  };

  roots.forEach((root) => {
    const gallery = root.querySelector(
      '[data-f2w-fighter-gallery]'
    );

    const track = gallery?.querySelector(
      '[data-slider-track]'
    );

    const slides = track
      ? [...track.querySelectorAll(
          '[data-f2w-lightbox-trigger]'
        )]
      : [];

    const previous = gallery?.querySelector(
      '[data-slider-prev]'
    );

    const next = gallery?.querySelector(
      '[data-slider-next]'
    );

    const counter = gallery?.querySelector(
      '[data-f2w-gallery-counter]'
    );

    const lightbox = root.querySelector(
      '[data-f2w-lightbox]'
    );

    const lightboxImage = lightbox?.querySelector(
      '[data-f2w-lightbox-image]'
    );

    const lightboxCaption = lightbox?.querySelector(
      '[data-f2w-lightbox-caption]'
    );

    const lightboxClose = lightbox?.querySelector(
      '[data-f2w-lightbox-close]'
    );

    const lightboxPrevious = lightbox?.querySelector(
      '[data-f2w-lightbox-prev]'
    );

    const lightboxNext = lightbox?.querySelector(
      '[data-f2w-lightbox-next]'
    );

    const correction = root.querySelector(
      '.f2w-fighter-v2__correction'
    );

    let activeIndex = 0;

    const correctionMessage = correction?.querySelector(
      '.f2w-event-submit__success, .f2w-event-submit__errors'
    );

    if (correctionMessage && correction) {
      correction.open = true;
    }

    const updateGallery = () => {
      if (!track || !slides.length) return;

      const maxScroll =
        track.scrollWidth -
        track.clientWidth -
        2;

      setHidden(
        previous,
        track.scrollLeft <= 2
      );

      setHidden(
        next,
        track.scrollLeft >= maxScroll
      );

      if (counter) {
        const current = Math.min(
          slides.length,
          Math.max(
            1,
            Math.round(
              track.scrollLeft /
              Math.max(1, track.clientWidth)
            ) + 1
          )
        );

        counter.textContent =
          `${current} / ${slides.length}`;
      }
    };

    const scrollGallery = (direction) => {
      if (!track) return;

      track.scrollBy({
        left:
          direction *
          Math.max(1, track.clientWidth),
        behavior: 'smooth'
      });
    };

    const renderLightbox = (index) => {
      const slide = slides[index];
      const image = slide?.querySelector('img');

      if (
        !slide ||
        !image ||
        !lightbox ||
        !lightboxImage
      ) {
        return;
      }

      activeIndex = index;

      lightboxImage.src = slide.href;
      lightboxImage.alt = image.alt || '';

      if (lightboxCaption) {
        lightboxCaption.textContent =
          slide.dataset.f2wLightboxCaption || '';

        lightboxCaption.hidden =
          !lightboxCaption.textContent;
      }

      lightbox.hidden = false;
      lightbox.setAttribute(
        'aria-hidden',
        'false'
      );

      document.body.classList.add(
        'open-lightbox'
      );

      lightboxClose?.focus();
    };

    const closeLightbox = () => {
      if (!lightbox) return;

      lightbox.hidden = true;

      lightbox.setAttribute(
        'aria-hidden',
        'true'
      );

      document.body.classList.remove(
        'open-lightbox'
      );
    };

    const moveLightbox = (direction) => {
      if (!slides.length) return;

      renderLightbox(
        (
          activeIndex +
          direction +
          slides.length
        ) % slides.length
      );
    };

    previous?.addEventListener(
      'click',
      () => scrollGallery(-1)
    );

    next?.addEventListener(
      'click',
      () => scrollGallery(1)
    );

    track?.addEventListener(
      'scroll',
      updateGallery,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      updateGallery
    );

    if (track && typeof window.ResizeObserver === 'function') {
      const galleryResizeObserver = new window.ResizeObserver(updateGallery);
      galleryResizeObserver.observe(track);
    }

    slides.forEach((slide, index) => {
      slide.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          renderLightbox(index);
        }
      );
    });

    lightboxClose?.addEventListener(
      'click',
      closeLightbox
    );

    lightboxPrevious?.addEventListener(
      'click',
      () => moveLightbox(-1)
    );

    lightboxNext?.addEventListener(
      'click',
      () => moveLightbox(1)
    );

    lightbox?.addEventListener(
      'click',
      (event) => {
        if (event.target === lightbox) {
          closeLightbox();
        }
      }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (!lightbox || lightbox.hidden) {
          return;
        }

        if (event.key === 'Escape') {
          closeLightbox();
        }

        if (event.key === 'ArrowLeft') {
          moveLightbox(-1);
        }

        if (event.key === 'ArrowRight') {
          moveLightbox(1);
        }
      }
    );

    updateGallery();
  });
})();

